import { Popover, Typography } from "@material-ui/core";
import { Check } from "lucide-react";
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "hooks/useMediaQuery";

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(2),
    width: "280px",
  },
}));

const BundleService = (props) => {
  const { service } = props;

  const classes = useStyles();

  const { isMobile } = useMediaQuery();

  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div className="service-item">
      <Check />
      <div>
        {isMobile ? (
          <h5
            aria-owns={open ? `popover-${service.id}` : undefined}
            aria-haspopup="true"
            onClick={handlePopoverOpen}
            className="service-item-title"
          >
            {service.title || service.label}
          </h5>
        ) : (
          <h5
            aria-owns={open ? `popover-${service.id}` : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
            className="service-item-title"
          >
            {service.title || service.label}
          </h5>
        )}
        {!!service.title && <p>{service.label}</p>}

        <Popover
          id={`popover-${service.id}`}
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <h5 className="popover-title">{service.title || service.label}</h5>
          {!!service.title && (
            <h6 className="popover-subtitle">{service.label}</h6>
          )}
          <p className="popover-description">{service.description}</p>
        </Popover>
      </div>
    </div>
  );
};

export default BundleService;
